import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryBaseDetails (params) {
  return request({
    ...APIS['@baseDetail/Query_Base_Details'],
    params
  })
}
// 查看资源包下产品发放详情记录
export function queryReleaseRecord (params) {
  return request({
    ...APIS['@baseDetail/Query_Release_Record'],
    params
  })
}

// 查看详情变更具体数据
export function queryDetailsChange (params) {
  return request({
    ...APIS['@baseDetail/Query_Details_Change'],
    params
  })
}
// 查看详情变更具体数据
export function checkLock (params) {
  return request({
    ...APIS['@baseDetail/Check_Lock'],
    params
  })
}

// 查询基地各运营年度下所有资源（用于下拉）
export function queryAllResource (params) {
  return request({
    ...APIS['@baseDetail/Query_All_Resource'],
    params
  })
}

// 资源归属调整（子记录)
export function changeSubOwnership (params) {
  return request({
    ...APIS['@baseDetail/Change_Sub_Ownership'],
    params
  })
}

export function queryDistributionSubRecords (params) {
  return request({
    ...APIS['@baseDetail/Query_DistributionSubRecords'],
    params
  })
}

export function queryReleaseRecordCheck (params) {
  return request({
    ...APIS['@baseDetail/QueryReleaseRecordCheck'],
    params
  })
}

export function queryAllReleaseRecord (data) {
  return request({
    ...APIS['@baseDetail/Query_AllReleaseRecord'],
    data
  })
}

export function checkChangeOwnershipParent (params) {
  return request({
    ...APIS['@baseDetail/Check_Change_Ownership_Parent'],
    params
  })
}

export function checkChangeOwnership (params) {
  return request({
    ...APIS['@baseDetail/Check_Change_Ownership'],
    params
  })
}

export function changeOwnershipParent (data) {
  return request({
    ...APIS['@baseDetail/Change_Ownership_Parent'],
    data
  })
}

export function changeOwnershipSubrecord (data) {
  return request({
    ...APIS['@baseDetail/Change_Ownership_subrecord'],
    data
  })
}

export function deletePre (data) {
  return request({
    ...APIS['@baseDetail/Delete_Pre'],
    data
  })
}

export function queryPreDetailsChange (params) {
  return request({
    ...APIS['@baseDetail/Query_Pre_Details_Change'],
    params
  })
}

export function exportBaseDetails (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@baseDetail/Export_BaseDetails'],
    params,
    headers,
    responseType
  })
}

export function exportReleaseRecord (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@baseDetail/Export_ReleaseRecord'],
    params,
    headers,
    responseType
  })
}

export function exportOperatorYearReleaseRecord (data) {
  // const headers = {
  //   'Content-Type': 'application/octet-stream'
  // }
  const responseType = 'blob'
  return request({
    ...APIS['@baseDetail/Export_operatorYear_ReleaseRecord'],
    data,
    responseType
  })
}

export function cancelPre (data) {
  return request({
    ...APIS['@baseDetail/CancelPre'],
    data
  })
}

export function confirmPre (data) {
  return request({
    ...APIS['@baseDetail/ConfirmPre'],
    data
  })
}
